"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VisitService = /** @class */ (function () {
    function VisitService() {
        this.storageKey = 'visits';
    }
    Object.defineProperty(VisitService.prototype, "visits", {
        get: function () {
            var value = localStorage.getItem(this.storageKey);
            return JSON.parse(value);
        },
        enumerable: true,
        configurable: true
    });
    VisitService.prototype.logVisit = function (path) {
        var visits = this.visits || [];
        var newVisit = {
            TimeStamp: Date.now(),
            Path: path
        };
        visits.push(newVisit);
        this.saveVisits(visits);
    };
    VisitService.prototype.saveVisits = function (visits) {
        localStorage.setItem(this.storageKey, JSON.stringify(visits));
    };
    return VisitService;
}());
exports.VisitService = VisitService;
